module.exports = __webpack_public_path__ + "img/MyTickets.0d1ef469.png";